export const settings = {
  en: {
    // ── A branch's own page ─────────────────────────────────────────────────
    branchOpen: "Open",
    branchGeofence: "Geofence",
    branchBack: "All branches",
    branchDetailsTitle: "Details and attendance policy",
    branchEditAction: "Edit branch",
    branchEmployeesTitle: "Employees at this branch",
    branchEmployeesHint: "Read through each person's active contract — the contract places somebody at a branch, not the employee record.",
    branchEmployeesEmpty: "Nobody has an active contract at this branch.",
    branchFilesTitle: "Branch documents",
    branchFilesHint: "The commercial registration, the lease, the municipality licence, the civil defence certificate. Give each one an expiry date and you will be warned before it lapses. The system stores the file and does not read it.",
    branchFilesEmpty: "No documents yet.",
    // The two ways of drawing the same list — see the View type in
    // BranchFilesPanel. "Sheet" rather than "grid" or "gallery": it is a
    // contact sheet, a page of pictures you scan to find one.
    branchFilesViewList: "List",
    branchFilesViewGrid: "Sheet",
    branchFilesCount: "{count} documents",
    branchFileAdd: "Add a document",
    branchFileName: "What is it?",
    branchFileChoose: "File (PDF, PNG or JPEG, up to 10 MB)",
    branchFileExpiry: "Expires on (optional)",
    branchFileDeleteTitle: "Remove this document?",
    branchFileDeleteBody: "The stored copy is deleted. The original paper is unaffected.",
    branchFileTooLarge: "That file is larger than 10 MB.",
    branchFileUnsupported: "Only PDF, PNG and JPEG files can be attached.",
    branchFileUnreadable: "That file could not be read. Please choose it again.",
    // The dashboard card. Its own card rather than a row inside the employee
    // one — see BranchFilesExpiringCard.
    branchFilesExpiringTitle: "Branch licences expiring",
    branchFilesExpiringEmpty: "No branch document is close to expiring.",

    holidayDeleteTitle: "Remove this holiday?",
    holidayDeleteBody: "Attendance for every date it covers will be recalculated as a normal working day.",

    leaveTypesTitle: "Leave types",
    leaveTypeNew: "Add a leave type",
    leaveTypeEditTitle: "Edit leave type",
    leaveTypeCode: "Code",
    leaveTypeCodeHint: "Lowercase letters, digits and underscores. It identifies the type in the system and can never be changed afterwards.",
    leaveTypeNameEn: "Name (English)",
    leaveTypeNameAr: "Name (Arabic)",
    leaveTypeAccrual: "Accrual",
    leaveTypeQuota: "Annual quota (days)",
    leaveTypeConsumes: "Draws on balance",
    leaveTypePaid: "Paid",
    leaveTypeAttachment: "Requires an attachment",
    leaveTypeOrder: "Sort order",
    leaveTypeUsage: "In use",
    leaveTypeUsageNone: "Never used",
    leaveTypeUsageN: "{n} record(s)",
    leaveTypeDeactivate: "Deactivate",
    leaveTypeActivate: "Reactivate",
    leaveTypeActive: "Active",
    leaveTypeInactive: "Retired",
    // Shown on the edit form for annual leave, beside the fields it greys out.
    leaveTypeContractOwned: "Annual leave is set by the contract. Its entitlement is the contract's figure raised to the statutory floor — 21 days under five years of service, 30 from five years — so the accrual model and quota cannot be set here, and it must keep drawing on its balance. The names and sort order are yours to change.",
    leaveTypeAccrualHelp: "Accrual builds up day by day from the contract. A fixed quota grants the same number of days each year. Unpaid neither accrues nor is paid.",
    leaveTypeDeleteTitle: "Delete this leave type?",
    leaveTypeDeleteBody: "It has never been used, so nothing refers to it. A type that has been used is retired instead.",
    leaveTypeDeactivateTitle: "Retire this leave type?",
    leaveTypeDeactivateBody: "It stops being offered on new requests. Everything already filed against it stays readable.",
    accrualAccrual: "Accrues",
    accrualFixedQuota: "Fixed quota",
    accrualUnpaid: "Unpaid",

    holidaysTitle: "Public holidays",
    holidayAdd: "Add a public holiday",
    holidayNameEn: "Name (English)",
    holidayNameAr: "Name (Arabic)",
    holidayStart: "First day",
    holidayEnd: "Last day",
    holidayDays: "Days",
    holidayNDays: "{n} days",
    holidayOneDay: "1 day",
    // Says "company-wide" plainly, because the branch column that used to be
    // in this table is gone and somebody will look for it.
    holidayNote: "Holidays are company-wide and apply to every branch. Most Saudi public holidays run several days — enter the whole period rather than one row per day.",
    deviceRetire: "Retire",
    deviceActivate: "Activate",
    auditTitle: "Audit trail",
    auditNote: "Every change recorded, newest first. Filter by record type, or enter a record number to follow one thing through.",
    auditKind: "Record type",
    auditRecordId: "Record number",
    auditActor: "Who",
    auditAction: "Action",
    auditRecord: "Record",
    auditEmpty: "No matching entries.",
    departments: "Departments",
    departmentsEmpty: "No departments yet. A contract needs one, so add them before hiring into this branch.",
    departmentNew: "New department",
    departmentClose: "Close",
    departmentReopen: "Reopen",
    departmentClosed: "Closed",
    branchNew: "Add a branch",
    branchEdit: "Branch",
    branchDetails: "Details",
    branchCode: "Code",
    branchName: "Name",
    branchNameAr: "Name (Arabic)",
    branchCity: "City",
    branchAddress: "Address",
    branchActive: "This branch is open",
    branchHours: "Working hours",
    branchTimezone: "Timezone",
    branchWorkStart: "Starts",
    branchWorkEnd: "Ends",
    branchLateGrace: "Late grace (minutes)",
    branchReminders: "Punch reminders",
    branchRemindersNote: "Times come from this branch's own hours above. A negative number reminds before the boundary, a positive one after. Each person gets at most one reminder of each kind per day, and only on a device where they have turned notifications on.",
    branchRemindCheckIn: "Remind to check in",
    branchRemindCheckOut: "Remind to check out",
    branchRemindOn: "On",
    branchRemindAfter: "Minutes (− before)",
    branchWeekend: "Weekend days",
    day1: "Mon", day2: "Tue", day3: "Wed", day4: "Thu", day5: "Fri", day6: "Sat", day7: "Sun",
    branchAttendance: "Attendance",
    branchMode: "How attendance is recorded",
    modeOpen: "Open — accept any check-in",
    modeGps: "GPS — must be at the branch",
    modeBiometric: "Device — recorded at a terminal",
    modeOpenNote: "Any check-in is accepted, wherever it comes from.",
    modeBiometricNote: "Staff clock in at the terminal. Check-in from the app is refused at this branch.",
    countedFrom: "Counting attendance from",
    countedFromOff: "Leave empty and this branch is not counting attendance: the register proposes nothing for it, and no absence can reach payroll from it. Set a date when you are ready to start.",
    countedFromNote: "Working days from this date with nothing recorded are proposed as absences in the register. A proposal is not a deduction — somebody has to confirm it before payroll sees it.",
    modeBiometricNoIngest: "Nothing can collect punches from a terminal yet. This mode correctly refuses check-in from the app — so a branch set to it records no attendance at all, by any route, until the device is wired up. Registering a device does not change that.",
    modeBiometricBlocked: "Device attendance needs at least one active device registered below. Add one, save, then reopen this branch to select it.",
    branchLatitude: "Latitude",
    branchLongitude: "Longitude",
    branchRadius: "Radius (metres)",
    branchGeofenceNote: "Leave the location blank and check-in will be accepted anywhere — a branch is never locked out by a missing setting.",
    devices: "Attendance devices",
    devicesEmpty: "No devices registered for this branch.",
    deviceAdd: "Register a device",
    deviceName: "Name",
    deviceType: "Type",
    deviceManufacturer: "Manufacturer",
    deviceModel: "Model",
    deviceSerial: "Serial number",
    deviceIdentifier: "Device identifier",
    deviceConnection: "Connection",
    deviceLastSync: "Last sync",
    deviceNeverSynced: "Never",
    deviceIdentifierNote: "The identifier the device reports as itself. It must be unique across every branch.",
  },
  ar: {
    // ââ A branch's own page âââââââââââââââââââââââââââââââââââââââââââââââââ
    branchOpen: "فتح",
    branchGeofence: "النطاق الجغرافي",
    branchBack: "كل الفروع",
    branchDetailsTitle: "البيانات وسياسة الحضور",
    branchEditAction: "تعديل الفرع",
    branchEmployeesTitle: "موظفو هذا الفرع",
    branchEmployeesHint: "تُقرأ من عقد كل موظف الساري — العقد هو من يحدد فرع الموظف، وليس سجله الشخصي.",
    branchEmployeesEmpty: "لا يوجد موظف بعقد سارٍ في هذا الفرع.",
    branchFilesTitle: "مستندات الفرع",
    branchFilesHint: "السجل التجاري، عقد الإيجار، رخصة البلدية، شهادة الدفاع المدني. أضف تاريخ انتهاء لكل مستند لتصلك تنبيهات قبل انتهائه. النظام يحفظ الملف ولا يقرأه.",
    branchFilesEmpty: "لا توجد مستندات بعد.",
    branchFilesViewList: "قائمة",
    branchFilesViewGrid: "جرد",
    branchFilesCount: "{count} مستند",
    branchFileAdd: "إضافة مستند",
    branchFileName: "ما هو المستند؟",
    branchFileChoose: "الملف (PDF أو PNG أو JPEG، حتى 10 ميجابايت)",
    branchFileExpiry: "تاريخ الانتهاء (اختياري)",
    branchFileDeleteTitle: "حذف هذا المستند؟",
    branchFileDeleteBody: "ستُحذف النسخة المحفوظة. الورقة الأصلية لا تتأثر.",
    branchFileTooLarge: "حجم الملف أكبر من 10 ميجابايت.",
    branchFileUnsupported: "يمكن إرفاق ملفات PDF و PNG و JPEG فقط.",
    branchFileUnreadable: "تعذر قراءة هذا الملف. يرجى اختياره مرة أخرى.",
    branchFilesExpiringTitle: "رخص الفروع المقتربة من الانتهاء",
    branchFilesExpiringEmpty: "لا يوجد مستند فرع قريب من الانتهاء.",

    holidayDeleteTitle: "حذف هذه العطلة؟",
    holidayDeleteBody: "سيُعاد احتساب الحضور في كل يوم تشمله كيوم عمل عادي.",

    leaveTypesTitle: "أنواع الإجازات",
    leaveTypeNew: "إضافة نوع إجازة",
    leaveTypeEditTitle: "تعديل نوع الإجازة",
    leaveTypeCode: "الرمز",
    leaveTypeCodeHint: "أحرف إنجليزية صغيرة وأرقام وشرطة سفلية. يُعرّف النوع في النظام ولا يمكن تغييره لاحقاً.",
    leaveTypeNameEn: "الاسم (بالإنجليزية)",
    leaveTypeNameAr: "الاسم (بالعربية)",
    leaveTypeAccrual: "طريقة الاحتساب",
    leaveTypeQuota: "الحصة السنوية (أيام)",
    leaveTypeConsumes: "يُخصم من الرصيد",
    leaveTypePaid: "مدفوعة",
    leaveTypeAttachment: "تتطلب مرفقاً",
    leaveTypeOrder: "الترتيب",
    leaveTypeUsage: "الاستخدام",
    leaveTypeUsageNone: "لم يُستخدم",
    leaveTypeUsageN: "{n} سجل",
    leaveTypeDeactivate: "إيقاف",
    leaveTypeActivate: "إعادة تفعيل",
    leaveTypeActive: "مفعّل",
    leaveTypeInactive: "متوقف",
    leaveTypeContractOwned: "الإجازة السنوية يحددها العقد. استحقاقها هو رقم العقد مرفوعاً إلى الحد النظامي — 21 يوماً لمن خدمته أقل من خمس سنوات، و30 يوماً من خمس سنوات فأكثر — لذلك لا يمكن تحديد طريقة الاحتساب أو الحصة هنا، ويجب أن تبقى تُخصم من رصيدها. أما الأسماء والترتيب فلك تغييرها.",
    leaveTypeAccrualHelp: "الاحتساب التدريجي يتراكم يوماً بيوم من العقد. الحصة الثابتة تمنح العدد نفسه كل سنة. وبدون راتب لا تتراكم ولا تُدفع.",
    leaveTypeDeleteTitle: "حذف نوع الإجازة؟",
    leaveTypeDeleteBody: "لم يُستخدم من قبل ولا يشير إليه أي سجل. أما النوع المستخدم فيتم إيقافه بدلاً من حذفه.",
    leaveTypeDeactivateTitle: "إيقاف نوع الإجازة؟",
    leaveTypeDeactivateBody: "لن يعود متاحاً في الطلبات الجديدة. وكل ما سُجّل عليه سابقاً يبقى ظاهراً.",
    accrualAccrual: "تراكمي",
    accrualFixedQuota: "حصة ثابتة",
    accrualUnpaid: "بدون راتب",

    holidaysTitle: "العطل الرسمية",
    holidayAdd: "إضافة عطلة رسمية",
    holidayNameEn: "الاسم (بالإنجليزية)",
    holidayNameAr: "الاسم (بالعربية)",
    holidayStart: "أول يوم",
    holidayEnd: "آخر يوم",
    holidayDays: "الأيام",
    holidayNDays: "{n} أيام",
    holidayOneDay: "يوم واحد",
    holidayNote: "العطل تشمل الشركة بأكملها وتنطبق على جميع الفروع. معظم العطل الرسمية في السعودية تمتد عدة أيام — أدخل الفترة كاملة بدلاً من صف لكل يوم.",
    deviceRetire: "إيقاف الجهاز",
    deviceActivate: "تفعيل الجهاز",
    auditTitle: "سجل التدقيق",
    auditNote: "كل تغيير مسجّل، الأحدث أولاً. صفِّ حسب نوع السجل أو أدخل رقم سجل لتتبعه.",
    auditKind: "نوع السجل",
    auditRecordId: "رقم السجل",
    auditActor: "المستخدم",
    auditAction: "الإجراء",
    auditRecord: "السجل",
    auditEmpty: "لا توجد نتائج مطابقة.",
    departments: "الأقسام",
    departmentsEmpty: "لا توجد أقسام بعد. العقد يتطلب قسماً، لذا أضفها قبل التوظيف في هذا الفرع.",
    departmentNew: "قسم جديد",
    departmentClose: "إغلاق",
    departmentReopen: "إعادة فتح",
    departmentClosed: "مغلق",
    branchNew: "إضافة فرع",
    branchEdit: "الفرع",
    branchDetails: "البيانات",
    branchCode: "الرمز",
    branchName: "الاسم",
    branchNameAr: "الاسم (بالعربية)",
    branchCity: "المدينة",
    branchAddress: "العنوان",
    branchActive: "الفرع مفتوح",
    branchHours: "ساعات العمل",
    branchTimezone: "المنطقة الزمنية",
    branchWorkStart: "البداية",
    branchWorkEnd: "النهاية",
    branchLateGrace: "سماح التأخير (دقائق)",
    branchReminders: "تذكير البصم",
    branchRemindersNote: "الأوقات تؤخذ من دوام هذا الفرع أعلاه. والرقم السالب يذكّر قبل الموعد، والموجب بعده. ولكل موظف تذكيرٌ واحد من كل نوع في اليوم على الأكثر، وعلى الأجهزة التي فعّل فيها الإشعارات فقط.",
    branchRemindCheckIn: "تذكير بتسجيل الحضور",
    branchRemindCheckOut: "تذكير بتسجيل الانصراف",
    branchRemindOn: "مفعّل",
    branchRemindAfter: "بكم دقيقة (بالسالب قبل)",
    branchWeekend: "أيام نهاية الأسبوع",
    day1: "الاثنين", day2: "الثلاثاء", day3: "الأربعاء", day4: "الخميس", day5: "الجمعة", day6: "السبت", day7: "الأحد",
    branchAttendance: "الحضور",
    branchMode: "طريقة تسجيل الحضور",
    modeOpen: "مفتوح — قبول أي تسجيل",
    modeGps: "الموقع — يجب التواجد في الفرع",
    modeBiometric: "الجهاز — التسجيل عبر جهاز البصمة",
    modeOpenNote: "يُقبل أي تسجيل حضور من أي مكان.",
    modeBiometricNote: "يسجل الموظفون الحضور عبر الجهاز. لا يُقبل التسجيل من التطبيق في هذا الفرع.",
    countedFrom: "بدء احتساب الحضور من",
    countedFromOff: "اتركه فارغاً ولن يحتسب هذا الفرع الحضور: لن يقترح السجل شيئاً، ولن يصل أي غياب إلى الرواتب منه. حدد تاريخاً عندما تكون جاهزاً للبدء.",
    countedFromNote: "أيام العمل من هذا التاريخ التي لم يُسجَّل فيها شيء ستُقترح كغياب في السجل. الاقتراح ليس خصماً — يجب أن يؤكده شخص قبل أن تراه الرواتب.",
    modeBiometricNoIngest: "لا توجد حتى الآن أي وسيلة لاستقبال البصمات من الجهاز. هذا الوضع يرفض التسجيل من التطبيق — وهو سلوك صحيح — ما يعني أن الفرع لن يسجل أي حضور بأي طريقة حتى يتم ربط الجهاز. تسجيل الجهاز في النظام لا يغيّر ذلك.",
    modeBiometricBlocked: "يتطلب الحضور بالجهاز تسجيل جهاز فعّال واحد على الأقل أدناه. أضف جهازاً ثم احفظ وأعد فتح الفرع لاختياره.",
    branchLatitude: "خط العرض",
    branchLongitude: "خط الطول",
    branchRadius: "نطاق التغطية (متر)",
    branchGeofenceNote: "إذا تُرك الموقع فارغاً فسيُقبل التسجيل من أي مكان — لا يتم إغلاق الفرع بسبب إعداد ناقص.",
    devices: "أجهزة الحضور",
    devicesEmpty: "لا توجد أجهزة مسجلة لهذا الفرع.",
    deviceAdd: "تسجيل جهاز",
    deviceName: "الاسم",
    deviceType: "النوع",
    deviceManufacturer: "الشركة المصنعة",
    deviceModel: "الطراز",
    deviceSerial: "الرقم التسلسلي",
    deviceIdentifier: "معرّف الجهاز",
    deviceConnection: "طريقة الاتصال",
    deviceLastSync: "آخر مزامنة",
    deviceNeverSynced: "لا يوجد",
    deviceIdentifierNote: "المعرّف الذي يرسله الجهاز عن نفسه. يجب أن يكون فريداً على مستوى جميع الفروع.",
  },
} as const;
